var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "task-module-rules-settings" }, [
    _c("div", { staticClass: "page-header" }, [
      _c("div", [
        _c("div", [
          _c("h2", [_vm._v(_vm._s(_vm.$t("taskModuleRules.settingsTitle")))]),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("p", { staticClass: "description" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("taskModuleRules.settingsDescription")) +
                "\n            "
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "workflow-selector" },
      [
        _c("label", [_vm._v(_vm._s(_vm.$t("taskModuleRules.selectWorkflow")))]),
        _vm._v(" "),
        _c(
          "a-select",
          {
            staticClass: "workflow-select",
            attrs: {
              "show-search": "",
              placeholder: _vm.$t("taskModuleRules.selectWorkflowPlaceholder"),
              "filter-option": _vm.filterWorkflow,
            },
            model: {
              value: _vm.selectedWorkflowId,
              callback: function ($$v) {
                _vm.selectedWorkflowId = $$v
              },
              expression: "selectedWorkflowId",
            },
          },
          _vm._l(_vm.workflows, function (workflow) {
            return _c(
              "a-select-option",
              { key: workflow._id, attrs: { value: workflow._id } },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(workflow.title) +
                    "\n            "
                ),
              ]
            )
          }),
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _vm.selectedWorkflowId
      ? _c(
          "div",
          { staticClass: "rules-content" },
          [
            _c("TaskModuleRules", {
              attrs: { "workflow-id": _vm.selectedWorkflowId },
            }),
          ],
          1
        )
      : _c("div", { staticClass: "empty-state" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("h3", [_vm._v(_vm._s(_vm.$t("taskModuleRules.selectWorkflow")))]),
          _vm._v(" "),
          _c("p", [
            _vm._v(_vm._s(_vm.$t("taskModuleRules.selectWorkflowHint"))),
          ]),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "empty-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("account_tree")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }